module.exports = __webpack_public_path__ + "static/media/fotogalereya9.209eede4.jpg";